// import Home from "./pages/Home"
// import './App.css';

// function App() {
//   return <Home />;
// }

// export default App;

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./pages/Home";
import ProductDetails from "./components/ProductDetails";
import { ContactProvider } from "./components/ContactContext"

// import SuperManager from "./pages/SuperManager";
// import Contact from "./pages/Contact";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/products/:productId", element: <ProductDetails /> },
  // { path: "/supermanager", element: <SuperManager /> },
  // { path: "/contact", element: <Contact /> },
]);

function App() {

  return (
    <ContactProvider>
      <RouterProvider router={router} />
    </ContactProvider>
  );
}

export default App;

